






















import Vue from 'vue'
import { Component } from 'vue-property-decorator'

import AutoRedirect from '../../directives/auto-redirect'

@Component({
  directives: {
    AutoRedirect,
  },
})
export default class NotFound extends Vue {
}
